<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">God Mode
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">Baby please. I'm a God. (lol)</p>
            </div>
        </div>

        <div class="flex flex-row items-center justify-end gap-x-4">

            <div class="hidden sm:block">
                <nav aria-label="Tabs" class="flex space-x-2">
                    <a (click)="selectedTab.set('top-up-requests')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('top-up-requests')">Top Up Requests</a>
                    <a (click)="selectedTab.set('pricing-models')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('pricing-models')">Pricing Models</a>
                    <a (click)="selectedTab.set('carousel')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('carousel')">Carousel</a>
                    <a (click)="selectedTab.set('all-activity')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('all-activity')">All Activity</a>
                    <a (click)="selectedTab.set('video-views')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('video-views')">Video Views</a>
                </nav>
            </div>
        </div>
    </div>

    <!-- Main Tabbed Section -->
    <div class="h-full min-h-0 flex-1 flex flex-col w-full overflow-hidden">
        @switch (selectedTab()) {
        @case ('top-up-requests') {
            <gmo-top-up-requests></gmo-top-up-requests>
        }
        @case ('pricing-models') {
            <gmo-pricing-models></gmo-pricing-models>
        }
        @case ('carousel') {
            <gmo-carousel></gmo-carousel>
        }
        @case ('all-activity') {
            <gmo-all-activity></gmo-all-activity>
        }
        @case ('video-views') {
            <gmo-video-views></gmo-video-views>
        }
        @default {
        Payouts
        }
        }
    </div>
    <!-- Main Tabbed Section - END -->
</div>